import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { CalculationService, DataService, DateService, HelperService, HTTPService, SocketService, ValidationService } from 'app/services';
import { billPaymentTypes, config, messages, paymentTypes } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { paymentObject } from 'app/services/sharedInterfaces';
import { currency } from 'app/constants/currency.constants';

import { environment } from 'environments/environment';

import { orderBy, sum, camelCase } from 'lodash';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-purchase-payment-order',
  templateUrl: './purchase-payment-order.component.html',
  styleUrls: ['./purchase-payment-order.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class PurchasePaymentOrder implements OnInit, OnDestroy {
  @ViewChild('#activate') myDiv: ElementRef<HTMLElement>;
  isArchived: boolean;
  estimateSearchResults: any[] = [];
  customerSearchResults: any[] = [];
  paymentMethods: any[] = [];
  payrixPaymentMethod: any[] = [];
  cashPaymentMethods: any[] = [];
  cardPaymentMethods: any[] = [];
  otherPaymentMethods: any[] = [];
  defaultTitle: string = config.defaultTitle;
  noCustomerText: string = config.noCustomerTitle;
  noEmailText: string = config.noEmail;
  usd = currency.USD;
  selectedPaymentMethod: any = {};
  previousCollectedAmount: number = 0;
  validate: any = {};
  remainingBalance: any = 0;
  paymentId: any;
  reviewConfiguration: any;
  isLoadingResults: boolean = true;
  disabled: boolean = false;
  workFlowDisabled: boolean = false;
  isProcessing: boolean = false;
  isNewPayment: boolean = true;
  isOrderEditable: boolean = true;
  isCustomerEditable: boolean = true;
  paymentHistory: any = [];
  focus: any = { collectedAmount: false };
  paymentTypes: any[] = paymentTypes;
  paymentMethodsActive = {
    cheque: true,
    cash: true,
    card: true,
  };
  maxDateRange: any = new Date();
  activePayment: any = this.paymentTypes[0];
  payRixResponse: any = {};
  payment: any = {
    _id: '',
    title: '',
    code: '',
    isOnline: false,
    paymentProvider: '',
    paymentType: this.activePayment.value,
    collectedAmount: null,
    isPaidFull: false,
    isPreviousPaid: false,
    isUnpaidStatus: false,
    createdAt: '',
    method: {
      methodId: '',
      qboId: '',
      name: '',
      type: '',
    },
    cardType: '',
    card4Digits: '',
    cardConfNo: '',
    checkNo: '',
    notes: '',
    isOldOrder: false,
    poNumber: '',
    supplier: '',
  };
  isSearching: boolean = false;
  paymentTime: any = '';
  isQboConnected: any = false;
  collectedAmmount: any;
  confirmCardPattern: any = { '0': { pattern: new RegExp('[a-zA-Z0-9]') } };
  isConfigLoading: boolean = false;
  isPaymentLoading: boolean = false;
  isMethodLoading: boolean = false;
  enableMandatoryVin: boolean = false;
  orderVehicle: any;
  isPaymentOnline = false;
  showNotes = true;
  dataServiceSubscription: Subscription;
  win: any;
  opening = false;
  featureIsPayRixEnable: boolean;
  isPayrixConnected: Boolean;
  merchantId: string;
  apiKey: string;
  //  to show card drop down, confirmation and last 4 digits
  afterPayrixPayment = false;
  terminalList: any[] = [];
  isSwipeOnline: boolean = false;
  activeTerminal: any;
  selectedTerminal: {
    isTransactionPending: any;
    name: string;
    id: string;
  };
  afterSwipePayment: boolean;
  isServicePending: boolean = false;
  purshaedOrderValue: any = {};
  purchaseOrderId: string;
  sourceId: string;
  private credentials: paymentObject;
  private socketListner: Subscription;
  private transactionDialogue: DynamicDialogRef;
  private isSwipeRequestPending: boolean = false;
  manualOrder: any;
  purchaseOrder: any;
  type = '';
  nexPartConstant = 'nextPart';
  partsTechConstant = 'partsTech';
  isCalculateChangeEnabled: boolean = false;
  supplier: string = '';
  changePaymentData: boolean = false;
  isPaymentDataPrivilgesEnabled: boolean = false;
  isOpenFromSplitDeliveries: boolean = false;
  grandCartSummary: any = {
    deliver: 0,
    grand: 0,
    paid: 0,
    part: 0,
    subTotal: 0,
    tire: 0,
    unpaid: 0,
  };
  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    public validationService: ValidationService,
    public dataService: DataService,
    public dateService: DateService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private calculationService: CalculationService,
    private cdr: ChangeDetectorRef,
    private socket: SocketService,
    private activatedRoute: ActivatedRoute
  ) {
    this.featureIsPayRixEnable = this.dataService.isOnlinePaymentEnable;
    this.isPayrixConnected = this.dataService.isPayrixConnected;
    this.isCalculateChangeEnabled = this.dataService.isCalculateChangeEnabled;
  }

  ngOnInit() {
    const poId = this.activatedRoute.snapshot.paramMap.get('id');

    const data = this.dConfig.data;
    this.fetchPaymentMethods();
    this.isQboConnected = this.helperService.getCompany().qbo;

    if (this.isQboConnected) {
      this.paymentTypes = billPaymentTypes;
      this.activePayment = this.paymentTypes[0];
    }

    if (data) {
      if (data?.estimate?.sourceId) {
        this.type = data.estimate.source;
        this.sourceId = data.estimate.sourceId;
        const estimate = data.estimate;
        this.supplier = estimate.supplier;
        this.payment.estimate = data;
        this.manualOrder = data.estimate.manualOrder;
        this.isOpenFromSplitDeliveries = data?.isOpenFromSplitDeliveries;

        if (this.isOpenFromSplitDeliveries) {
          this.grandCartSummary = data?.estimate?.grandCartSummary;
        }

        this.setEstimateDetails(estimate);
      }

      // For re-new payment
      if (data?.estimate && data?.isNewPayment) {
        //  for new payment PO
        this.purchaseOrderId = data.estimate.purchaseOrderId;
        this.getPaymentDetails({}, true);
      }

      // Incase of edit payment
      if (data?.payment && data?.paymentId) {
        this.sourceId = data.payment.sourceId;
        this.type = data.payment.source;
        this.manualOrder = data.payment.manualOrder;

        if (this.manualOrder) {
          this.manualOrder.qouteId = data.payment.qouteId;
        }

        if (!this.type) {
          this.purchaseOrderId = data.payment?.purchaseOrder?.purchaseOrderId || data.payment?.partsOrder?.moduleId;
        }

        this.paymentId = data.paymentId;

        if (this.manualOrder) {
          this.type = this.manualOrder.source;
          let purchaseOrderRes = {
            title:
              this.type === this.nexPartConstant
                ? 'Nexpart'
                : this.type === 'manualOrder'
                  ? 'Manual Order Parts'
                  : this.type === 'RepairLink'
                    ? 'RepairLink'
                    : this.type === 'speedDial'
                      ? 'SpeedDial'
                      : 'PartsTech',
            code: '',
            cash: this.manualOrder.paymentDetails.cash,
            cheque: this.manualOrder.paymentDetails.cheque,
            card: this.manualOrder.paymentDetails.card,
            bank: this.manualOrder.paymentDetails.bank,
            creditCard: this.manualOrder.paymentDetails.creditCard,
            otherCurrentAsset: this.manualOrder.paymentDetails.otherCurrentAsset,
            total: { grand: this.manualOrder.paymentDetails.grand },
            totalDue: { total: this.manualOrder.paymentDetails.grand },
            unpaid: { total: this.manualOrder.paymentDetails.grand },
            workFlowStatus: 'Order',
          };

          let payload = {
            payment: data.payment,
            purchaseOrderRes: purchaseOrderRes,
          };

          this.setPaymentDetails(payload);
        } else {
          if (data.payment?.orderingType === 'purchaseOrder' && data.payment.typeSource === 'tireConnect') {
            this.getPaymentDetailsTireConnect(data.payment);
          } else {
            this.getPaymentDetails(data.payment);
          }

        }
      }

      if (!data?.paymentId && !data?.estimate?.sourceId) {
        const estimate = data.estimate;
        this.payment.estimate = data;
        this.purchaseOrder = data.estimate;
        this.setEstimateDetails(estimate);
      }
    }
    this.changePaymentData = this.dataService.changePaymentData;
    this.isPaymentDataPrivilgesEnabled = this.dataService.isPaymentDataPrivilgesEnabled;
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
    if (this.socketListner) {
      this.socketListner.unsubscribe();
    }
  }

  getPaymentDetailsTireConnect(payment, newPayment?: boolean) {
    this.isPaymentLoading = true;
    this.httpService.getPurchaseOrderTireConnectById(this.purchaseOrderId, true).then(
      (purchaseOrderRes: any) => {
        if (purchaseOrderRes) {
          purchaseOrderRes.bank = purchaseOrderRes?.total?.bank || 0;
          purchaseOrderRes.cash = purchaseOrderRes?.total?.cash || 0;
          purchaseOrderRes.card = purchaseOrderRes?.total?.card || 0;
          purchaseOrderRes.cheque = purchaseOrderRes?.total?.cheque || 0;
          purchaseOrderRes.creditCard = purchaseOrderRes?.total?.creditCard || 0;

          // set grand with taxed amount
          if (purchaseOrderRes?.total?.tax?.value) {
            purchaseOrderRes.items.map((item) => {
              purchaseOrderRes.total.grand = Number(purchaseOrderRes.total.grand) + (item?.isTaxable ? Number(item?.taxedAmount || 0) : 0);
            });
          }

          if (newPayment) {
            this.setEstimateDetails(purchaseOrderRes);
            return;
          }
          let payload = {
            payment,
            purchaseOrderRes,
          };
          this.setPaymentDetails(payload);
        }
      },
      (err) => {
        this.isPaymentLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  /** Getting payment details */
  getPaymentDetails(payment, newPayment?: boolean) {
    this.isPaymentLoading = true;
    this.httpService.getPurchaseOrderById(this.purchaseOrderId, true).then(
      (purchaseOrderRes: any) => {
        if (purchaseOrderRes) {
          if (newPayment) {
            this.setEstimateDetails(purchaseOrderRes);
            return;
          }
          let payload = {
            payment,
            purchaseOrderRes,
          };
          this.setPaymentDetails(payload);
        }
      },
      (err) => {
        this.isPaymentLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  clearSearchResult(type: string) {
    this.isSearching = false;
    if (type === 'order') {
      this.estimateSearchResults = [];
    } else {
      this.customerSearchResults = [];
    }
  }

  toggleEditMode(type: string) {
    if (this.isNewPayment) {
      if (type === 'order') {
        this.isOrderEditable = !this.isOrderEditable;
      } else {
        this.isCustomerEditable = !this.isCustomerEditable;
      }
    }
  }

  /** Getting amount from the input box and calculating the remaining balance */
  handleChange(value: any, field: string) {
    if (field === 'collectedAmount') {
      this.payment[field] = !isNaN(value.replace(',', '')) ? Number(value.replace(',', '')) : value;
      this.payment.estimate.unpaid = this.payment.estimate.total - this.payment.collectedAmmount;
    } else if (field !== 'card4Digits' && field !== 'cardConfNo' && field !== 'checkNo') {
      this.payment[field] = Number(value);
    } else {
      this.payment[field] = value;
    }

    this.calculateRemainingBalance();
  }

  /** Calculate remaining amount */
  calculateRemainingAmount() {
    const { total = 0, cash = 0, card = 0, cheque = 0, bank = 0, creditCard = 0, otherCurrentAsset = 0, paid } = this.payment.estimate;
    // otherCurrentAsset just removed this variable from Calculation we have cash,card and check as payment option
    let totalPreviousPaymentAmt = this.calculationService.roundOff(sum([cash, card, cheque, bank, creditCard]));

    if (this.isOpenFromSplitDeliveries) {
      totalPreviousPaymentAmt = paid || 0;
    }

    this.payment.estimate.paid = totalPreviousPaymentAmt;

    if (this.paymentId) {
      return this.calculationService.roundOff(total + this.previousCollectedAmount - totalPreviousPaymentAmt);
    } else {
      return this.calculationService.roundOff(total - totalPreviousPaymentAmt);
    }
  }

  /** Calculate and set remaining amount */
  calculateRemainingBalance() {
    this.collectedAmmount = -1;
    const { total = 0, cash = 0, card = 0, cheque = 0, unpaid = 0, bank = 0, creditCard = 0, otherCurrentAsset = 0, paid = 0 } = this.payment.estimate;
    const amount = this.payment.collectedAmount;
    const remainingAmount = this.calculateRemainingAmount();
    // otherCurrentAsset just removed this variable from Calculation we have cash,card and check as payment option
    let totalPreviousPaymentAmt = this.calculationService.roundOff(sum([cash, card, cheque, bank, creditCard]));

    if (this.isOpenFromSplitDeliveries) {
      totalPreviousPaymentAmt = paid;
    }

    if (amount && amount <= remainingAmount) {
      if (this.paymentId) {
        this.remainingBalance = total + this.previousCollectedAmount - (amount + totalPreviousPaymentAmt);
      } else {
        this.remainingBalance = total - (amount + totalPreviousPaymentAmt);
      }

      this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);
      this.validate.amount = '';
    } else if (!amount) {
      if (this.paymentId) {
        this.remainingBalance = total + this.previousCollectedAmount - ((amount || 0) + totalPreviousPaymentAmt);
        this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);
      } else {
        this.remainingBalance = total - ((amount || 0) + totalPreviousPaymentAmt);
        this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);
      }
    } else {
      this.validate.amount = '* Amount must be less than the remaining balance';
      this.collectedAmmount = 0;
      this.remainingBalance = this.calculateRemainingAmount();
    }

    if (this.remainingBalance < 0.45) {
      if (this.isOpenFromSplitDeliveries) {
        const totalAmountToBePaid = this.calculationService.roundOff(this.grandCartSummary?.paid + remainingAmount);
        this.payment.isPaidFull = this.grandCartSummary?.paid > 0 ? this.grandCartSummary?.grand === totalAmountToBePaid : this.grandCartSummary?.unpaid <= 0;
      } else {
        this.payment.isPaidFull = true;
      }
    } else {
      if (!this.disabled) {
        this.payment.isPaidFull = false;
      }
    }
  }

  onEstimateSearch(value: string) {
    let query = '';
    query = `search=${value}&sort=createdAt&order=-1&activeOnly=false&limit=20&skip=0`;

    this.isSearching = true;
    this.httpService.estimateSearch(query).then(
      (estimates) => {
        if (estimates.records && estimates.records.length) {
          this.estimateSearchResults = estimates.records.map((estimate: any) => ({
            ...estimate,
            isArchived: !estimate.isArchived,
          }));
        }
        this.isSearching = false;
      },
      (err) => {
        this.isSearching = false;
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  onCardTypeSelect(card: any) {
    this.payment.cardType = card.name;
    this.selectedPaymentMethod = card;
  }

  onDateTimeChange(date: any) {
    this.payment.paymentDate = date;
  }

  closePaymentModal(data: any) {
    if (this.afterPayrixPayment || this.afterSwipePayment) {
      this.onSubmit(true);
    }
    this.ref.close(data);
  }

  markPaymentComplete() {
    const hasRemaining = this.calculationService.roundOffToDecimalPlaces(this.calculateRemainingAmount() - this.payment.collectedAmount);
    if (hasRemaining) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          title: 'Mark RO as Paid',
          message: 'The amount entered is less then the total Order value, are you sure you want to continue?',
          button: {
            success: { title: 'Continue' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe((confirm) => {
        if (confirm.isSuccess) {
          this.payment._id = this.paymentId;

          if (this.paymentId) {
            this.updateTransaction();
          } else {
            this.createTransaction();
          }
        }
        onClose.unsubscribe();
      });
    } else {
      this.payment._id = this.paymentId;
      if (this.paymentId) {
        this.updateTransaction();
      } else {
        this.createTransaction();
      }
    }
  }

  handleFocus() {
    this.focus.collectedAmount = true;
    this.validate.amount = '';
    if (isNaN(this.payment.collectedAmount)) {
      this.payment.collectedAmount = 0;
    }
  }

  showSelected(type: string) {
    if (type === 'order') {
      if (this.payment.estimate && this.payment.estimate.estimateId) {
        this.isOrderEditable = false;
      }
    } else {
      if (this.payment.customer && this.payment.customer.customerId) {
        this.isCustomerEditable = false;
      }
    }
  }

  /** Getting paid full change */
  handleIsPaidChange(isPaidFull: boolean) {
    this.payment.isPaidFull = isPaidFull;
  }

  displayNameEmail(fullName: string, email: string) {
    if (fullName && email) {
      return `${fullName} - ${email}`;
    } else if (fullName) {
      return `${fullName}`;
    }
  }

  /** Populate Estimate Details */
  setEstimateDetails(order: any) {
    this.payment = {
      ...this.payment,
      poNumber: this.manualOrder?.poNumber,
      supplier: this.supplier,
      estimate: {
        purchaseOrderId: order._id,
        title: order.title,
        code: order.code,
        invCode: order.invCode,
        createdAt: this.dateService.getCurrentDateTimeTz(new Date(order.createdAt).getTime()),
        orderStatus: order.orderStatus,

        cash: this.calculationService.roundOff(order.cash || 0),
        cheque: this.calculationService.roundOff(order.cheque || 0),
        card: this.calculationService.roundOff(order.card || 0),
        bank: this.calculationService.roundOff(order.bank || 0),
        creditCard: this.calculationService.roundOff(order.creditCard || 0),
        otherCurrentAsset: this.calculationService.roundOff(order.otherCurrentAsset || 0),

        total: order.total.grand || 0,
        totalDue: order.total.grand || 0,
        unpaid: order.total.unpaid || 0,
        paid: order.total.paid || 0,
        // bank: order.bank || order.paid || 0,
      },
      // notes: order.notes,
      paymentDate: this.dateService.getCurrentDateTimeTz(new Date().getTime()),
    };

    if (order.orderingType === 'purchaseOrder' && order.orderType === 'TireConnect') {
      this.payment.estimate.partsOrderId = order.partsOrderId;
      delete this.payment.estimate.purchaseOrderId;
    }

    if (order.cartGroupId) {
      this.payment.cartGroupDetails = {
        cartGroupId: order.cartGroupId,
        totalDue: order.total.grand || 0,
        cartGrand: order.total.cartGrand,
      };
    }

    this.paymentTime = this.dateService.getCurrentDateTimeTz(new Date().getTime());
    this.remainingBalance = this.calculateRemainingAmount();
    this.payment.collectedAmount = this.calculationService.roundOff(this.remainingBalance);
    //here we overwrite payment title for purchase order
    if (order.supplier && order.supplier.name) {
      this.updatePaymentTitle(order.supplier.name);
    }

    this.calculateRemainingBalance();
    this.validate.amount = '';
    this.getPaymentHistory(this.payment._id);
    this.isPaymentLoading = false;
    this.checkMarkOrderAsPaid();
    console.log('setEstimateDetails', this.helperService.deepCopy(this.payment));
  }

  checkMarkOrderAsPaid() {
    this.payment.isPaidFull = this.remainingBalance + (this.payment?.refundToDate || 0) === 0;
  }

  setPaymentMethod() {
    if (this.payment.paymentMethod && this.payment.paymentMethod.methodId && this.paymentMethods.length) {
      const [paymentMethod] = this.paymentMethods.filter(({ _id }) => _id === this.payment.paymentMethod.methodId);
      const [activePaymentType] = this.paymentTypes.filter(({ value }) => this.payment.paymentType === value);

      if (paymentMethod && activePaymentType) {
        this.selectedPaymentMethod = paymentMethod;
        this.activateMethodCard(activePaymentType);
      }
    }
  }

  paymentMethod(data) {
    if (this.afterPayrixPayment) {
      return;
    } else {
      this.isPaymentOnline = data;
      this.isSwipeOnline = !data;
    }

    if (this.featureIsPayRixEnable && this.isPaymentOnline && !this.isSwipeOnline && this.activePayment.value === 'card') {
      this.showNotes = false;
    } else {
      this.showNotes = true;
    }
  }

  onChangenNote(event) {
    if (this.paymentId) {
      this.payment.notes = event;
    }
  }

  /** Populate Payment Details */
  setPaymentDetails(payment: any) {
    const estimate = payment.payment;

    //here we overwrite payment title for nexPart, partsTech and manualOrder
    if (!estimate.title && this.type) {
      estimate.title =
        this.type === this.nexPartConstant
          ? 'Nexpart'
          : this.type === 'manualOrder'
            ? 'Manual Order Parts'
            : this.type === 'RepairLink'
              ? 'RepairLink'
              : this.type === 'speedDial'
                ? 'SpeedDial'
                : 'PartsTech';
    }

    this.purshaedOrderValue = payment.purchaseOrderRes;
    this.paymentId = estimate._id;
    this.payment = {
      _id: estimate._id,
      title: estimate.title || '',
      code: estimate.code || '',
      paymentType: estimate.paymentType,
      notes: estimate.notes,
      card4Digits: estimate.card4Digits,
      cardConfNo: estimate.cardConfNo,
      checkNo: estimate.checkNo,
      collectedAmount: this.calculationService.roundOff(estimate.amount),
      isPaidFull: estimate.estimateId && estimate.estimateId.isPaidFull,
      paymentMethod: estimate.paymentMethod,
      estimate: {},
    };
    this.previousCollectedAmount = this.calculationService.roundOff(this.payment.collectedAmount);
    this.disabled = false;

    this.setPaymentMethod();

    if (this.purshaedOrderValue) {
      this.payment.estimate = {
        code: this.purshaedOrderValue.code,
        title: estimate.title,
        cash: this.calculationService.roundOff(this.purshaedOrderValue.cash),
        cheque: this.calculationService.roundOff(this.purshaedOrderValue.cheque),
        card: this.calculationService.roundOff(this.purshaedOrderValue.card),
        bank: this.calculationService.roundOff(this.purshaedOrderValue.bank),
        otherCurrentAsset: this.calculationService.roundOff(this.purshaedOrderValue.otherCurrentAsset),
        creditCard: this.calculationService.roundOff(this.purshaedOrderValue.creditCard),
        total: this.calculationService.roundOff(this.purshaedOrderValue.total.grand),
        totalDue: this.calculationService.roundOff(this.purshaedOrderValue.total.total),
        paid: this.calculationService.roundOff(this.purshaedOrderValue.total.paid - this.payment.collectedAmount),
        unpaid: this.calculationService.roundOff(this.purshaedOrderValue.total.unpaid),
        workFlowStatus: (estimate.workFlowStatus && this.purshaedOrderValue.workFlowStatus.name) || '',
        createdAt: this.dateService.getCurrentDateTimeTz(new Date(this.purshaedOrderValue.createdAt).getTime()),
      };
      this.paymentTime = this.dateService.getCurrentDateTimeTz(new Date(this.purshaedOrderValue.createdAt).getTime());
      //here we overwrite payment title for purchase order
      if (payment.purchaseOrderRes && payment.purchaseOrderRes.supplier && payment.purchaseOrderRes.supplier.name) {
        this.updatePaymentTitle(payment.purchaseOrderRes.supplier.name);
      }

      if (!!estimate.paymentDate) {
        if (this.helperService.isAppleDevice()) {
          estimate.paymentDate = this.dateService.madeDateStringIOSCompatible(estimate.paymentDate);
        }
        this.payment.paymentDate = new Date(estimate.paymentDate);
        this.paymentTime = this.payment.paymentDate;
      } else {
        this.payment.paymentDate = this.dateService.getCurrentDateTimeTz(new Date(estimate.createdAt).getTime());
        this.paymentTime = this.payment.paymentDate;
      }
    }

    this.remainingBalance = this.calculateRemainingAmount();
    this.calculateRemainingBalance();
    if (this.purshaedOrderValue._id) {
      this.getPaymentHistory(this.purshaedOrderValue._id);
    }
  }

  activateMethodCard(method: any, changed = false) {
    if (this.afterPayrixPayment) {
      return;
    }

    if (this.isQboConnected) {
      if (method.value.toLowerCase() === 'creditcard') {
        this.paymentMethods = [...this.cardPaymentMethods];
      } else if (method.value.toLowerCase() === 'bank') {
        this.paymentMethods = [...this.cashPaymentMethods];
      } else {
        this.paymentMethods = [...this.otherPaymentMethods];
      }
    } else {
      if (method.value === 'card') {
        this.paymentMethods = [...this.cardPaymentMethods];
      } else if (method.value === 'cash') {
        this.paymentMethods = [...this.cashPaymentMethods];
      } else {
        this.paymentMethods = [...this.otherPaymentMethods];
      }
    }
    if (this.paymentMethods.length) {
      this.activePayment = method;
      if (changed) {
        this.selectedPaymentMethod = this.paymentMethods[0];
      }
    }
  }

  /** Fetch payments and set the qboId for the non credit card payment */
  fetchPaymentMethods() {
    if (!environment.isMock) {
      this.isMethodLoading = true;
      this.httpService.getActivePaymentMethods(true).then(
        (paymentMethods: any[]) => {
          this.paymentMethods = paymentMethods.filter(({ integrationType }) => integrationType === 'accPayable');

          if (this.isQboConnected) {
            this.paymentMethods.forEach((method) => {
              if (method.type === 'creditCard') {
                this.cardPaymentMethods.push(method);
              } else if (method.type === 'bank') {
                this.cashPaymentMethods.push(method);
              } else if (method.type === 'otherCurrentAsset') {
                // this.otherPaymentMethods.push(method);
              }
            });
          } else {
            this.paymentMethods.forEach((method) => {
              if (method.type === 'CREDIT_CARD') {
                this.cardPaymentMethods.push(method);
              } else if (method.type === 'CASH') {
                this.cashPaymentMethods.push(method);
              } else if (method.name.toLowerCase().includes('cash')) {
                this.cashPaymentMethods.push(method);
              } else {
                this.otherPaymentMethods.push(method);
              }
            });
          }

          this.paymentMethodsActive = {
            card: !!this.cardPaymentMethods.length,
            cash: !!this.cashPaymentMethods.length,
            cheque: !!this.otherPaymentMethods.length,
          };

          if (!this.paymentId && this.cashPaymentMethods.length) {
            this.selectedPaymentMethod = this.cashPaymentMethods[0];
            this.activateMethodCard(this.paymentTypes[0]);
          }

          if (!this.paymentId) {
            if (this.cashPaymentMethods.length) {
              this.selectedPaymentMethod = this.cashPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[0]);
            } else if (this.cardPaymentMethods.length) {
              this.selectedPaymentMethod = this.cardPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[1]);
            } else if (this.otherPaymentMethods.length) {
              this.selectedPaymentMethod = this.otherPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[2]);
            }
          }
          this.isMethodLoading = false;
          this.setPaymentMethod();
        },
        (err) => {
          this.isMethodLoading = false;
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  /** Fetching payment history */
  getPaymentHistory(estimateId: string) {
    if (!estimateId) return;

    const data = this.dConfig.data;
    if (data?.payment?.orderingType === 'purchaseOrder' && data?.payment?.typeSource === 'tireConnect') {
      estimateId = data?.payment?.partsOrder?.moduleId;
    }
    this.httpService.paymentPurchaseOrder(estimateId, false, data?.payment?.typeSource === 'tireConnect').then(
      (payments: any[]) => {
        this.paymentHistory = [];

        if (payments && payments.length) {
          this.paymentHistory = [];
          payments.forEach((payment: any) => {
            if (payment.refunds && payment.refunds.length) {
              payment.refunds.forEach((refund) => {
                this.paymentHistory.push({
                  createdAt: this.dateService.getCurrentDateTimeTz(new Date(refund.refundDate).getTime()),
                  tooltip: '',
                  amount: refund.amount,
                  paymentType: 'Refund',
                });
              });
            }

            this.paymentHistory.push({
              amount: payment.amount,
              isOnline: payment.isOnline,
              isCardSwipe: payment.isCardSwipe,
              paymentType: payment.paymentType,
              cardType: payment.cardType,
              confirmationCode: payment.card4Digits,
              parRix: payment.payrixResponse,
              madeBy: payment.paymentHistory && payment.paymentHistory.length ? payment.paymentHistory[0].fullName : '',
              createdAt: !!payment.paymentDate ? new Date(payment.paymentDate) : this.dateService.getCurrentDateTimeTz(new Date(payment.createdAt).getTime()),
              tooltip: this.helperService.createPaymentLogTooltip(payment),
            });
          });

          this.paymentHistory = orderBy(this.paymentHistory, ['createdAt'], 'desc');
          this.isPaymentLoading = false;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  /** Validate payment data */
  validation() {
    this.focus.collectedAmount = false;
    if (this.payment.collectedAmount === '.') {
      this.payment.collectedAmount = 0;
    }

    let isFormValid = true;
    this.validate = {};

    if (this.payment.collectedAmount === 0) {
      this.validate.amount = '* Amount should be greater than 0';
      isFormValid = false;
    }

    if (this.payment.estimate.estimateId === '') {
      this.validate.estimate = '* Please enter estimate';
      isFormValid = false;
    }

    if (this.payment.collectedAmount > this.calculateRemainingAmount()) {
      this.validate.amount = '* Amount must be lesser than remaining balance';
      isFormValid = false;
    }

    if (this.payment.refundToDate > this.payment.collectedAmount) {
      this.validate.amount = '* Payment amount must be greater then Refunds';
      isFormValid = false;
    }

    if (!this.selectedPaymentMethod || (this.selectedPaymentMethod && !this.selectedPaymentMethod._id)) {
      isFormValid = false;
    }

    return isFormValid;
  }

  onSubmit(isForced: boolean = false) {
    if (this.isProcessing || this.isConfigLoading || this.isPaymentLoading || this.isMethodLoading) {
      return;
    }
    if (this.activePayment.value === 'card' && this.isPaymentOnline && !this.afterPayrixPayment && !this.paymentId && !this.isSwipeOnline) {
      this.helperService.showToaster('error', 'Please complete your payment');
      return;
    }

    if (this.enableMandatoryVin && ((this.orderVehicle && !this.orderVehicle.VIN) || (this.payment.vehicle && !this.payment.vehicle.VIN)) && !isForced) {
      this.handleVinPrompt({
        title: `Add VIN to Invoice RO`,
        message: `${this.orderVehicle ? this.orderVehicle.name : this.payment.vehicle.name} does not contain VIN. Please enter the VIN before Invoicing.`,
        success: 'Enter VIN',
        cancel: 'Add payment',
        type: 'invoice',
      });
      return;
    }

    if (this.validation()) {
      this.payment.amount = Number(this.payment.collectedAmount);
      if (this.manualOrder) {
        this.payment.isOldOrder = this.manualOrder.isOldOrder;
      }
      if (this.payment.isPaidFull) {
        this.markPaymentComplete();
      } else {
        if (this.paymentId) {
          this.updateTransaction();
        } else {
          this.createTransaction();
        }
      }
    }
  }

  handleVinPrompt({ title, message, success, cancel, type, payload }: any) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title,
        message,
        button: {
          success: { title: success },
          cancel: { title: cancel },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        const vehicle = this.orderVehicle ? this.orderVehicle : this.payment.vehicle;

        if (!vehicle) return;

        if (!vehicle.vehicleId) vehicle.vehicleId = vehicle._id;

        const customer = this.payment.customer;
        customer._id = customer.customerId;

        customer.vehicleId = vehicle.vehicleId;
        customer.highLightedVIN = true;
        this.dataService.sendData(this.dataService.typeSidebar('vehicle', customer.customerId, customer.fullName, customer));
      } else {
        if (data.btn === 'close') return;
        this.onSubmit(true);
      }

      onClose.unsubscribe();
    });
  }

  /** Update payment transaction */
  updateTransaction() {
    this.payment._id = this.paymentId;
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    this.payment.paymentType = this.activePayment.value;

    this.payment.notes = this.payment.notes;
    this.payment.paymentMethod = {
      methodId: this.selectedPaymentMethod._id,
      qboId: this.selectedPaymentMethod.qboId,
      name: this.selectedPaymentMethod.name,
      type: this.selectedPaymentMethod.type,
    };

    const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
    const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
    const paymentDate = `${date} ${time}`;
    this.payment.estimate.purchaseOrderId = this.purchaseOrderId;
    if (this.manualOrder) {
      this.payment.estimate.estimateId = this.manualOrder.estimateId;
    }
    const purchaseOrder = this.payment.estimate;

    let payload = { ...this.payment, purchaseOrder, paymentDate };
    const data = this.dConfig.data?.payment;
    payload.poNumber = data.poNumber;
    payload.supplier = data.supplier;
    if (data.source === 'partsTech') {
      payload.poNumber = data.manualOrder?.partsTechPoNumber;
    }
    if (data.source === 'manualOrder') {
      payload.supplier = data.manualOrder?.supplier?.name;
    }
    if (this.sourceId) {
      // payload.source = camelCase(this.type);
      payload.source = this.type;
      payload.sourceId = this.sourceId;
    } else {
      if (data.orderingType === 'purchaseOrder' && data.typeSource === 'tireConnect') {
        let tireConnectPayload = this.helperService.deepCopy(payload);
        tireConnectPayload.partsOrder = this.helperService.deepCopy(purchaseOrder);
        tireConnectPayload.source = 'partsOrder';
        tireConnectPayload.estimate.partsOrderId = data.partsOrder.moduleId;
        tireConnectPayload.partsOrder.moduleId = data.partsOrder.moduleId;
        delete tireConnectPayload.estimate.purchaseOrderId;
        delete tireConnectPayload.partsOrder.purchaseOrderId;
        delete tireConnectPayload.purchaseOrder;
        payload = tireConnectPayload;
      } else {
        payload.source = 'purchaseOrder';
      }
    }

    if (this.manualOrder && this.manualOrder.qouteId) {
      payload.qouteId = this.manualOrder.qouteId;
    }

    this.httpService.updatePaymentPurchaseOrder(payload).then(
      (payment) => {
        this.closePaymentModal({
          isSuccess: true,
          result: {
            isPaidFull: this.disabled ? false : this.payment.isPaidFull,
            payrixResponse: this.payRixResponse.payrixResponse || null,
            estimate: {
              _id: this.payment.estimate.estimateId,
              ...this.payment.estimate,
              customer: this.payment.customer,
              sourceId: this.sourceId,
            },
            payment,
            isPurchase: true,
          },
          reviewConfiguration: this.reviewConfiguration,
        });

        this.dataService.sendData(
          this.dataService.typePassData('payment-list', {
            isPaid: this.payment.isPaidFull,
            isPartitallyPaid: !this.payment.isPaidFull ? true : false,
          })
        );
        this.helperService.showToaster('success', messages.paymentSaved);
        this.isProcessing = false;
      },
      (err) => {
        this.helperService.showToaster('error', err);
        this.closePaymentModal({ isSuccess: false });
        this.isProcessing = false;
      }
    );
  }

  /** Making a new payment */
  createTransaction() {
    if (this.isProcessing) {
      return;
    }

    delete this.payment._id;
    this.isProcessing = true;
    this.payment.paymentType = this.activePayment.value;
    this.payment.paymentMethod = {
      methodId: this.selectedPaymentMethod._id,
      qboId: this.selectedPaymentMethod.qboId,
      name: this.selectedPaymentMethod.name,
      type: this.activePayment.value,
    };
    const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
    const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
    const paymentDate = `${date} ${time}`;
    if (this.manualOrder) {
      this.payment.estimate.estimateId = this.manualOrder.estimateId;
      this.payment.isPreviousPaid = this.manualOrder.paymentDetails.isPaidPartial;
      if (this.manualOrder.paymentDetails.paid == 0) {
        this.payment.isUnpaidStatus = true;
      }
    }
    const purchaseOrder = this.payment.estimate;
    const payload = { ...this.payment, purchaseOrder, paymentDate };
    const data = this.dConfig.data?.estimate;
    if (data.source === 'partsTech' && !data.poNumber) {
      payload.poNumber = data.manualOrder?.partsTechPoNumber;
      payload.supplier = data.supplier;
    }

    // if(this.)

    if (this.sourceId) {
      payload.source = this.type;
      payload.sourceId = this.sourceId;
    } else {
      if (data.orderingType === 'purchaseOrder' && data.orderType === 'TireConnect') {
        payload.source = 'partsOrder';
        purchaseOrder.moduleId = purchaseOrder.partsOrderId;
        delete purchaseOrder.partsOrderId;
        payload.partsOrder = purchaseOrder;
        delete payload.purchaseOrder;
      } else {
        payload.source = 'purchaseOrder';
      }

    }
    if (payload.source === 'purchaseOrder' || (payload.source === 'partsOrder' && data.orderingType === 'purchaseOrder' && data.orderType === 'TireConnect')) {
      payload.isPreviousPaid = this.purchaseOrder.isPaidPartial;
      if (this.purchaseOrder.paid == 0) {
        payload.isUnpaidStatus = true;
      }
    }
    console.log('createTransaction', this.helperService.deepCopy(payload));
    // return;
    this.httpService.createPaymentPurchaseOrder(payload).then(
      (payment) => {
        // payment through payrex and append ID in payment object.

        this.closePaymentModal({
          isSuccess: true,
          result: {
            isPaidFull: this.disabled ? false : this.payment.isPaidFull,
            estimate: {
              _id: this.payment.estimate.estimateId,
              ...this.payment.estimate,
            },
            amount: this.payment.collectedAmount,
            payment,
            isPurchase: true,
          },
          // reviewConfiguration: this.reviewConfiguration,
        });

        this.helperService.showToaster('success', messages.paymentCreated);
        this.dataService.sendData(
          this.dataService.typePassData('payment-list', {
            isPaid: this.payment.isPaidFull,
            isPartitallyPaid: !this.payment.isPaidFull ? true : false,
          })
        );
        this.isProcessing = false;
      },
      (error) => {
        this.helperService.showToaster('error', error);
        this.closePaymentModal({ isSuccess: false });
        this.isProcessing = false;
      }
    );
  }

  triggerFalseClick() {
    const el: HTMLElement = this.myDiv.nativeElement;
    el.click();
  }

  updatePaymentTitle(title) {
    if (!this.sourceId) {
      this.payment.estimate.title = title;
    }
  }

  validateChangePaymentData() {
    if (this.paymentId && !this.changePaymentData && this.isPaymentDataPrivilgesEnabled) {
      return true;
    }
    return false;
  }
}
